/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_AmountInputs */

const cs_deal_splits_amount = /** @type {(inputs: Deal_Splits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Částka`)
};

const en_deal_splits_amount = /** @type {(inputs: Deal_Splits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Deal_Splits_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_amount = /** @type {((inputs?: Deal_Splits_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_amount(inputs)
	return cs_deal_splits_amount(inputs)
});